<div class="barra-iconos-acciones">
  <div class="tooltip" >
    <app-icono-superior [icono]="'hs-download'" [id]="'Descargar'" (clickIcon)="botonAccionClicked($event)">
    </app-icono-superior>
    <app-custom-tooltip-sqp [textoTooltip]="getTooltip('Descargar')" [posicion]="'bottom'"></app-custom-tooltip-sqp>
  </div>

  <div class="tooltip">
    <app-icono-superior class="tooltip" [icono]="'icon-excel-empty'" [id]="'Excel'" (clickIcon)="botonAccionClicked($event)">
    </app-icono-superior>
    <app-custom-tooltip-sqp [textoTooltip]="getTooltip('Excel')" [posicion]="'bottom'"></app-custom-tooltip-sqp>
  </div>

  <div class="tooltip">
    <app-icono-superior class="tooltip" [icono]="'hs-doc'" [id]="'Pdf'" (clickIcon)="botonAccionClicked($event)">
    </app-icono-superior>
    <app-custom-tooltip-sqp [textoTooltip]="getTooltip('Pdf')" [posicion]="'bottom'"></app-custom-tooltip-sqp>
  </div>

  <div class="tooltip">
    <app-icono-superior class="tooltip" [icono]="'hs-bin'" [id]="'Eliminar'" (clickIcon)="botonAccionClicked($event)">
    </app-icono-superior>
    <app-custom-tooltip-sqp [textoTooltip]="getTooltip('Eliminar')" [posicion]="'bottom'"></app-custom-tooltip-sqp>
  </div>
</div>
